"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.personalData.name': 'Detección de Datos Personales',
    'tools.personalData.description': 'Extraer y categorizar datos personales de mensajes de usuarios como números de teléfono, correos electrónicos, direcciones, nombres, etc.',
};
